import { render, staticRenderFns } from "./RetailFiscalReceipt.vue?vue&type=template&id=56b9531e&scoped=true&"
import script from "./RetailFiscalReceipt.vue?vue&type=script&lang=js&"
export * from "./RetailFiscalReceipt.vue?vue&type=script&lang=js&"
import style0 from "./RetailFiscalReceipt.vue?vue&type=style&index=0&id=56b9531e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b9531e",
  null
  
)

export default component.exports